export default (context, payload) => {
    const moduleId = context.getters.moduleId;
    const apiData = context.rootState.appState.data;
    const setAttribute = payload.oneLni.storeUtils.setAttribute;

    // Set labels manually
    setAttribute(context, `${moduleId}_upload_document-type`, 'labelText', apiData['documents.label']);
    setAttribute(context, `${moduleId}_upload_document-type`, 'options', apiData['documents.options']);
    setAttribute(context, `${moduleId}_upload_file-upload`, 'fileTypes', apiData['documents.fileTypes']);
};